import React, { useState, useEffect, useRef } from "react";
import "./App.css";

const choices = [
  { name: "Rock", icon: "🪨" },
  { name: "Paper", icon: "📄" },
  { name: "Scissors", icon: "✂️" },
];

const ws_url = 'wss://rpsapi.sabreinwork.com:8765';

export default function App() {
  const [playerChoice, setPlayerChoice] = useState(null);
  const [actualOppChoice, setActualOppChoice] = useState(null);
  const [opponentChoice, setOpponentChoice] = useState(null);
  const [result, setResult] = useState(null);
  const [ws, setWS] = useState(null);
  const [userId, setUserId] = useState("");
  const userIdRef = useRef(userId); //necessary to keep call back up to date
  const [isReady, setIsReady] = useState(false);

  const roomCode = "ROOM123";

  function extractUserId(input) {
    const prefix = "userId:";
    if (input.startsWith(prefix)) {
      return input.slice(prefix.length);
    }
    return null; // or undefined, or throw an error, depending on your needs
  }

  function extractAfterColon(input) {
    const [userId, choice] = input.split(":");
    if (userId && choice !== undefined) {
      return { userId, choice };
    }
    return null; // or throw an error if format is invalid
  }

  useEffect(() => {
      const socket = new WebSocket(ws_url);
      setWS(socket)
  
      socket.onopen = () => {
        console.log("✅ Connected to server");
        socket.send("Connection established");
      };
  
      socket.onmessage = (event) => {
        console.log("📩 Received:", event.data);
        let newUID = extractUserId(event.data);
        console.log("userId: ", newUID)
        if (newUID !== null)
          setUserId(newUID);
        else {
          let response = extractAfterColon(event.data)
          console.log("respo: ", response)
          console.log("userId: ", userIdRef.current)
          console.log(response.userId !== userIdRef.current)
          if (response.userId !== userIdRef.current) {
            setActualOppChoice(response.choice)
          }
        }
      };
  
      socket.onclose = () => {
        console.log("❌ Disconnected from server");
      };
  
      return () => socket.close(); // Cleanup on unmount
    },[])

    useEffect(() => {
      userIdRef.current = userId;
    }, [userId])

    useEffect(() => {
      console.log("opponentChoice: ", actualOppChoice)
      console.log("isReady: ", isReady)
      if (isReady) {
        setOpponentChoice(actualOppChoice)
        if (playerChoice === actualOppChoice) {
          setResult("It's a Draw!");
        } else if (
          (playerChoice === "Rock" && actualOppChoice === "Scissors") ||
          (playerChoice === "Paper" && actualOppChoice === "Rock") ||
          (playerChoice === "Scissors" && actualOppChoice === "Paper")
        ) {
          setResult("You Win!");
        } else {
          setResult("You Lose!");
        }

        if (actualOppChoice === null) {
          setResult("waiting...")
          setIsReady(true)
        } else {
          setIsReady(false)
          setActualOppChoice(null)
        }
      }
    }, [isReady, actualOppChoice, playerChoice])

  const handleChoice = (choice) => {
    setPlayerChoice(choice);
    setResult(null);
  };

  const handleSubmit = () => {
    ws.send(userId + ":" + playerChoice)
    setIsReady(true);
  };

  const getIcon = (choiceName) => {
    const match = choices.find((c) => c.name === choiceName);
    return match ? match.icon : "❓";
  };

  return (
    <div className="app-container">
      <header className="header">
        <h1>RPS Multiplayer</h1>
        <div className="room-code">Room Code: <strong>{roomCode}</strong></div>
      </header>

      <main className="game-vertical">
        <div className="opponent-section">
          <h2>Opponent</h2>
          <div className="choice-display">
            {opponentChoice ? getIcon(opponentChoice) : "❓"}
          </div>
          <p>{opponentChoice ? opponentChoice : "Waiting..."}</p>
        </div>

        <div className="center-section">
          {!result && (
            <button className="submit-btn" onClick={handleSubmit} disabled={!playerChoice}>
              Submit
            </button>
          )}
          {result && (
            <div className="result">
              <h3>{result}</h3>
            </div>
          )}
        </div>


        <div className="player-section">
          <h2>You</h2>
          <div className="choice-buttons">
            {choices.map((choice) => (
              <button
                key={choice.name}
                className={`circle-btn ${playerChoice === choice.name ? "selected" : ""}`}
                onClick={() => handleChoice(choice.name)}
              >
                <span role="img" aria-label={choice.name}>{choice.icon}</span>
              </button>
            ))}
          </div>
          <p>Choice: <strong>{playerChoice || "None"}</strong></p>
        </div>
      </main>
    </div>
  );
}
